import Api from "../api";

const uri = "/api/ed/referidos";

export const getReferidos = (data) => {
  const fechaInicio = data?.fechaInicio;
  const fechaFin = data?.fechaFin;
  return Api.getInstance()
    .executeGetQuery(`${uri}?fechaInicio=${fechaInicio}&fechaFin=${fechaFin}`)
    .then((res) => res.data)
    .catch((err) => console.log(err));
};

export const getElegibilidadReferido = (data) => {
  const dpi = data?.dpi;
  return Api.getInstance()
    .executeGetQuery(`${uri}/elegibilidad?dpi=${dpi}`)
    .then((res) => res)
    .catch((err) => console.log(err));
};

export const getDepartamentos = () => {
  return Api.getInstance()
    .executeGetQuery(`${uri}/departamentos`)
    .then((res) => res.data)
    .catch((err) => console.log(err));
};

export const getMunicipios = (data) => {
  const idDepartamento = data?.idDepartamento;
  return Api.getInstance()
    .executeGetQuery(`${uri}/municipios?idDepartamento=${idDepartamento}`)
    .then((res) => res.data)
    .catch((err) => console.log(err));
};

export const getSucursales = (data) => {
  const idDepartamento = data?.idDepartamento;
  const idMunicipio = data?.idMunicipio;
  return Api.getInstance()
    .executeGetQuery(
      `${uri}/sucursales?idDepartamento=${idDepartamento}&idMunicipio=${idMunicipio}`
    )
    .then((res) => res.data)
    .catch((err) => console.log(err));
};

export const createReferido = (data) => {
  return Api.getInstance()
    .executeQuery(`${uri}`, data)
    .then((res) => res)
    .catch((err) => console.log(err));
};

export const createReferidoLote = (data) => {
  return Api.getInstance()
    .executeQuery(`${uri}/lote`, data)
    .then((res) => res)
    .catch((err) => console.log(err));
};
